<template>
  <div class="fif">
    <div class="top">
      <div class="weevip">
        <img src="../assets/weevip.png" alt="">
      </div>
      <div class="address">
        <!-- <i class="address-icon"></i> -->
        <div>
          <p>{{cname}}</p>
          <p>{{name}}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <span>十五天预报</span>
        <span>数据来源：accuwtather</span>
      </div>
      <div class="item" v-for="(item, index) in fifList" :key="index">
        <div class="left">
          <p>{{formatTimeWeek(item.Date, index)}}</p>
          <p>{{formatTime(item.Date)}}</p>
        </div>
        <div class="right">
          <div>
            <img class="item-icon" :src="iconImage(item.Day.Icon)"/><p style="width:16%">{{weatherCode[item.Day.Icon]}}</p><p style="width:10%">{{item.Temperature.Minimum.Value.toFixed()}}℃</p><p class="wind_text">{{item.Day.Wind.Direction.Localized}}风{{transformWind(item.Day.Wind.Speed.Value)}}</p>
          </div>
          <div>
            <img class="item-icon" :src="iconImage(item.Day.Icon)"/><p style="width:16%">{{weatherCode[item.Night.Icon]}}</p><p style="width:10%">{{item.Temperature.Maximum.Value.toFixed()}}℃</p><p class="wind_text">{{item.Night.Wind.Direction.Localized}}风{{transformWind(item.Night.Wind.Speed.Value)}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <img src="https://zky.koocdn.com/club/picture/eff9e000277f4180bc3760ef593d2753.png" alt="">
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import {weatherCode} from './../api/config'
export default {
  name: 'fif',
  data() {
    return {
      fifList: JSON.parse(localStorage.getItem('fiflist')),
      weatherCode: weatherCode,
      name: '',
      cname: ''
    }
  },
  created() {
    const {name, cname} = this.$route.query
    this.name = name || 'Maldives'
    this.cname = cname || '马尔代夫'
  },
  computed: {
    iconImage() {
      return function (icon) {
        return `http://images-test.weelv.com/weather/icon/black/${icon}.png`
      }
    }
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format('MM/DD')
    },
    transformWind(v) {
      const value = v / 3.6;
      if ( value <= 10 ) {
        return '1-2级';
      } else if (10 < value <= 17) {
        return '3-4级'
      } else if (17 < value <= 25) {
        return '4-5级'
      } else if (25 < value <= 34) {
        return '5-6级'
      } else if (34 < value <= 43) {
        return '6-7级'
      } else if (43 < value <= 54) {
        return '7-8级'
      } else if (54 < value <= 65) {
        return '8-9级'
      } else if (65 < value <= 77) {
        return '9-10级'
      } else if (77 < value <= 89) {
        return '10-11级'
      } else if (89 < value <= 102) {
        return '11-12级'
      } else {
        return '13级'
      }
    },
    formatTimeWeek(time, index) {
      if (index === 0) {
        return '今天'
      } else if (index === 1) {
        return '明天'
      } else if (index === 2) {
        return '后天'
      } else {
        const arr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        return  arr[new Date(time).getDay()]
      }
    }
  }
}
</script>

<style lang="stylus">
@import '../stylus/mixin.styl';
.item-icon
  width 20px
  height 20px
  display inline-block
  margin 0 3%
.fif
  background-color #f3f3f3
  .top
    height 171px
    background url('https://zky.koocdn.com/club/picture/88e129c9a5d943248a1ba9cddcbc9172.png') center no-repeat
    background-size cover
    position relative
    .weevip
      width 75px
      height 27px
      position absolute
      top 0
      right 0
      img
        display inline-block
        width 100%
        height 100%
    .address
      position absolute
      left 16px
      top 68px
      width 200px
      font-size 20px
      font-family PingFangSC-Semibold
      font-weight 600
      color rgba(216,184,119,1)
      line-height 20px
      display flex
      &-icon
        display inline-block
        width 11px
        height 13px
        background url('../assets/locationvip.png') center no-repeat
        background-size cover
        position relative
        top 1px
      div
        margin-left 9px
      p:nth-child(2)
        font-size 14px
        font-family PingFangSC-Light
        font-weight 300
  .content
    padding-bottom 15px
    position relative
    z-index 1
    margin -50px 15px 0px
    // height 880px
    background rgba(255,255,255,1)
    // box-shadow 0px 0px 12px 0px rgba(228, 228, 228, 0.35)
    border-top-left-radius 38px
    border-top-right-radius 38px
    border-bottom-left-radius 15px
    border-bottom-right-radius 15px
    .top
      position: relative;
      top: -1px;
      height 54px
      padding 23px 17px
      box-sizing border-box
      display flex
      justify-content space-between
      align-items center
      background rgba(39,39,41,1);
      border-top-left-radius 15px
      border-top-right-radius 15px
      font-size 16px
      font-family PingFangSC-Regular
      font-weight,400
      color rgba(255,255,255,1)
      span:nth-child(2)
        font-size 12px
        font-family PingFangSC-Regular
        font-weight 400
        color rgba(216,184,119,1)
    .item
      margin 16px 9px 0 9px
      height 75px
      background rgba(239,239,239,1)
      border-radius 6px
      font-size 14px
      font-family PingFangSC-Regular
      font-weight 400
      color rgba(48,48,48,1)
      line-height 1.5
      display flex
      align-items center
      padding 0 2% 0 0%
      .left
        display flex
        flex-direction column
        justify-content center
        height 46px
        width 70px
        text-align center
        border-right-1px(rgba(49,49,51,.1))
      .right
        text-align center
        flex 1
        .wind_text
          width 44%
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
        div
          line-height 28px
          height 28px
          vertical-align middle
          display flex
          align-items center
          p:nth-child(3)
            margin 0 8%
  .foot
    height 75px
    padding 0 17px
    display flex
    align-items center
    justify-content flex-end
    img
      width 185px
      height 22px
      display block
</style>

